export const servicesContent = {
    fr: {
        eyebrow: 'TARIFS',
        title: 'Choisissez votre formule',
        planTitles: { basic: 'Plan Basique', premium: 'Plan Standard', gold: 'Plan Premium' },
        badge: 'LE PLUS POPULAIRE',
        screensStandard: { basic: '1 appareil à la fois', premium: '1 appareil à la fois', gold: '2 appareils actifs' },
        screensMulti: { basic: '2 appareils actifs', premium: '3 appareils actifs', gold: '4 appareils actifs' },
        periodsStandard: { basic: '12 mois', premium: '15 mois (3 offerts)', gold: '15 mois (3 offerts)' },
        periodsMulti: { basic: '2 ans', premium: '15 mois', gold: '15 mois' },
        paymentOnce: 'Paiement unique',
        adultLine: 'Chaînes + films pour adultes (avec mot de passe) 🔞',
        beinStandard: 'beIN Sports, Canal+ & DAZN Sport, Rugby et Tennis',
        beinPremium: 'beIN Sports, Canal+ & DAZN Sport pour Football, Rugby et Tennis',
        features: [
            '+79,000 chaînes, +249,000 films et séries',
            'Toutes les chaînes premium',
            'Ligue 1 Plus + France en FULL HD / 4K ⚽️',
            '__BEIN__',
            'Eurosport France pour Tour de France et Roland Garros',
            'DAZN, Amazon Prime, Netflix, Disney+, Canal+ Séries, OCS, Apple TV+',
            'Films et séries illimités, SD / HD / FULL HD / 4K',
            'Serveurs rapides et stables, mis à jour régulièrement',
            'Lecteur IBO Pro gratuit inclus',
            'Service client 24/7 · Garantie de 15 jours',
        ],
        orderButton: 'Commander maintenant',
        securePayment: 'Paiement sécurisé garanti',
        whatsappOrderMessage: (title, price, period, screens) =>
            `Bonjour, je souhaite commander le ${title} à ${price} (${period}, ${screens}). Pouvez-vous m'aider à finaliser ma commande ?`,
        supportTitle: "Besoin de plus d'appareils ou d'une autre durée ?",
        supportBody: 'Écrivez-nous et nous préparons un plan sur mesure, tout de suite.',
        supportCta: 'Parler au support',
        lifetime: {
            badgeText: 'Offre limitée',
            title: 'Forfait à vie',
            description: 'Un seul paiement, un accès permanent à votre abonnement premium — sans renouvellement ni mauvaise surprise.',
            features: [
                { line1: 'Paiement unique', line2: "(pas d'abonnement)" },
                { line1: '2 écrans simultanés' },
                { line1: 'Accès complet au', line2: 'forfait Premium' },
                { line1: '30 jours garantie de', line2: 'remboursement' },
            ],
            priceNote: 'paiement unique',
            ctaLabel: 'Commander',
            securityLabel: 'Paiement 100 % sécurisé',
            whatsappMessage: "Bonjour, je souhaite commander le Forfait à vie à 129,00 € (paiement unique). Pouvez-vous m'aider à finaliser ma commande ?",
        },
    },
    es: {
        eyebrow: 'PRECIOS',
        title: 'Elige tu plan',
        planTitles: { basic: 'Plan Básico', premium: 'Plan Estándar', gold: 'Plan Premium' },
        badge: 'EL MÁS POPULAR',
        screensStandard: { basic: '1 dispositivo a la vez', premium: '1 dispositivo a la vez', gold: '2 dispositivos activos' },
        screensMulti: { basic: '2 dispositivos activos', premium: '3 dispositivos activos', gold: '4 dispositivos activos' },
        periodsStandard: { basic: '12 meses', premium: '15 meses (3 gratis)', gold: '15 meses (3 gratis)' },
        periodsMulti: { basic: '2 años', premium: '15 meses', gold: '15 meses' },
        paymentOnce: 'Pago único',
        adultLine: 'Canales + películas para adultos (con contraseña) 🔞',
        beinStandard: 'beIN Sports, Canal+ y DAZN Sport, Rugby y Tenis',
        beinPremium: 'beIN Sports, Canal+ y DAZN Sport para Fútbol, Rugby y Tenis',
        features: [
            '+79.000 canales, +249.000 películas y series',
            'Todos los canales premium',
            'LaLiga + Champions League en FULL HD / 4K ⚽️',
            '__BEIN__',
            'Eurosport para La Vuelta, el Tour de Francia y Roland Garros',
            'DAZN, Amazon Prime, Netflix, Disney+, Movistar Plus+, Apple TV+',
            'Películas y series ilimitadas, SD / HD / FULL HD / 4K',
            'Servidores rápidos y estables, actualizados con regularidad',
            'Reproductor IBO Pro gratis incluido',
            'Atención al cliente 24/7 · Garantía de 15 días',
        ],
        orderButton: 'Pedir ahora',
        securePayment: 'Pago 100% seguro garantizado',
        whatsappOrderMessage: (title, price, period, screens) =>
            `Hola, quiero pedir el ${title} a ${price} (${period}, ${screens}). ¿Podéis ayudarme a finalizar mi pedido?`,
        supportTitle: '¿Necesitas más dispositivos o una duración distinta?',
        supportBody: 'Escríbenos y te preparamos un plan a medida, al momento.',
        supportCta: 'Hablar con soporte',
        lifetime: {
            badgeText: 'Oferta limitada',
            title: 'Plan de por vida',
            description: 'Un único pago, acceso permanente a tu suscripción premium: sin renovaciones ni sorpresas.',
            features: [
                { line1: 'Pago único', line2: '(sin suscripción)' },
                { line1: '2 pantallas simultáneas' },
                { line1: 'Acceso completo al', line2: 'plan Premium' },
                { line1: 'Garantía de devolución', line2: 'de 30 días' },
            ],
            priceNote: 'pago único',
            ctaLabel: 'Pedir',
            securityLabel: 'Pago 100% seguro',
            whatsappMessage: 'Hola, quiero pedir el Plan de por vida a 129,00 € (pago único). ¿Podéis ayudarme a finalizar mi pedido?',
        },
    },
};
